<template>
<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
  <template v-slot:activator="{ on, attrs }">
    <v-icon
      color="blue darken-2"
      dark
      v-bind="attrs"
      v-on="on"
      class="mx-1"
    small>fas fa-eye</v-icon>
  </template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ subscription.product }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="dialog = false">Close</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div class="px-10">
    <v-row class="ma-0">
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">subscription Title</label>
        <h3 class="font-weight-regular">{{ subscription.product }}</h3>
      </v-col >
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">subscription Type</label>
        <h3 class="font-weight-regular">{{ subscription.type }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">subscription Start Date</label>
        <h3 class="font-weight-regular">{{ subscription.start_date }}</h3>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">subscription Paid Until</label>
        <h3 class="font-weight-regular">{{ subscription.paid_until }}</h3>
      </v-col>
    </v-row>
     <v-row class="ma-0">
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">Client</label>
        <h3 class="font-weight-regular">{{ subscription.client.name }}</h3>
      </v-col >
      <v-col cols="12" sm="6" md="3">
        <label class="body-2">subscription Status</label>
        <h3 class="font-weight-regular">{{ subscription.status }}</h3>
      </v-col>
    </v-row>
   
    </div>
  </v-card>
</v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    props: {
      subscription: Object,
      subscriptionid : Number
    },
    data: function() {
      return {
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      dialog: false,
      }
    },
    computed: {
      ...mapGetters(["allsubscriptions"]),
    }

  }
</script>